import {COUNTERTOP_GROUP} from "../../../../kvComponent/core/constants";
import {COUNTERTOP_GROUP_BATHROOM} from "../../../core/constants";
import {filterCartItems, sortCartItemsForListPage} from "../../../lookNavigation/lookFunctions2";

/**
 * @param cartItem {cartItemInterface}
 * @param property {string}
 * @returns {number|string}
 */
export const getCartItemShippingCost = (cartItem, property = "shippingCost") => {
  if (property !== "shippingCost") {
    return cartItem[property] || cartItem.cartFeature.dbFeature[property]
  }
  return (typeof cartItem.shippingCost === "number")
    ? cartItem.shippingCost
    : (typeof cartItem.cartFeature.dbFeature.shippingCost === "number")
      ? cartItem.cartFeature.dbFeature.shippingCost
      : 0
}

/**
 * returns array of deliveries
 * @param cartItems {[cartItemInterface]}
 * @returns {array}
 */
export const createDeliverySections = (cartItems) => {

  const cartItemsToInclude = filterCartItems(cartItems, true, true);
  const cartItemsList = sortCartItemsForListPage(cartItemsToInclude);

  let deliveries = [];
  cartItemsList.forEach(cartItem => {
    const cartItemShippingCost = getCartItemShippingCost(cartItem) || 0;
    const cartItemShippingName = getCartItemShippingCost(cartItem, "shippingName") || "Free";
    const cartItemShippingTime = getCartItemShippingCost(cartItem, "shippingTime") || "-";
    const cartItemShippingCode = getCartItemShippingCost(cartItem, "shippingCode") || "-";
    const existingDelivery = deliveries.find(delivery => {
      return delivery.price === cartItemShippingCost && delivery.name === cartItemShippingName
    });
    if (existingDelivery) {
      existingDelivery.cartItems.push(cartItem.id)
    } else {
      deliveries.push({
        price: cartItemShippingCost,
        name: cartItemShippingName,
        time: cartItemShippingTime,
        code: cartItemShippingCode,
        cartItems: [cartItem.id],
        // activeDeliveryIndex: deliveries.length,
      })
    }
  })
  return deliveries
}

export const setCartItemsShipping = (cartItems, shippingOptions = []) => {
  return cartItems.map(cartItem => {
    if (!cartItem.cartFeature || !cartItem.cartFeature.dbFeature) {
      return cartItem // no need to add a delivery
    }
    const shippingForItem = shippingOptions.find(shippingObject => shippingObject.dbFeatureId === cartItem.cartFeature.dbFeature.id);
    if (shippingForItem && shippingForItem.options && shippingForItem.options.length) {
      if (cartItem.shippingName && shippingForItem.options.some(option => option.title === cartItem.shippingName)) {
        return cartItem // already assigned, we already have been here
      }
      const firstOption = shippingForItem.options[0];
      return Object.assign({}, cartItem, {
        shippingCost: Math.trunc(firstOption.cost * 100) / 100,
        shippingName: firstOption.title,
        shippingTime: firstOption.delivery,
        shippingCode: firstOption.code,
      })
    } else if (cartItem.shippingName) {
      return cartItem  // already assigned, we already have been here
    } else if (cartItem.cartFeature.dbFeature.shippingCost || cartItem.cartFeature.dbFeature.shippingName) {
      return Object.assign({}, cartItem, {
        shippingCost: cartItem.cartFeature.dbFeature.shippingCost || 0,
        shippingName: getCartItemShippingCost(cartItem, "shippingName") || "Free",
        shippingTime: getCartItemShippingCost(cartItem, "shippingTime") || "-",
        shippingCode: getCartItemShippingCost(cartItem, "shippingCode") || "-",
      })
    } else {
      return Object.assign({}, cartItem, {
        shippingCost: 0,
        shippingName: "Free",
        shippingTime: "-",
        shippingCode: "-",
      })
    }
  })
}

const area2Codes = ["MN", "WI", "MI", "NY", "VT", "NH", "ME", "MA", "RI", "CT", "NJ"];
const area3Codes = ["WA", "OR", "CA", "AZ", "NV", "ID", "MT", "WY", "UT", "NM", "CO", "SD", "ND"];

const getAreaCost = (postalCode) => {
  if (area3Codes.includes(postalCode)) {
    return 295
  } else if (area2Codes.includes(postalCode)) {
    return 245
  }
  return 225
}

/**
 * @param deliveryCost {number}
 * @param cartItems {{cartItemInterface}}
 * @param storeState {object}
 * @returns {number}
 */
export const getCafeCountertopsDeliveryCost = (deliveryCost = 0, cartItems, storeState) => {
  let materialsQuantity = cartItems.reduce(((totalQuantity, cartItem) => {
    if (COUNTERTOP_GROUP.includes(cartItem.partId) || COUNTERTOP_GROUP_BATHROOM.includes(cartItem.partId)) {
      totalQuantity = totalQuantity + cartItem.quantity;
    }
    return totalQuantity
  }), 0)
  if (materialsQuantity === 0) {
    return deliveryCost
  }
  if (materialsQuantity < 10) {
    deliveryCost = deliveryCost + (95 * 2)
  } else if (materialsQuantity < 25) {
    const {stateShort, state} = storeState.paymentState.shippingAddress;
    const postalCode = stateShort || (state || "").slice(0, 2) || storeState.userState.userInfo.stateShort || (storeState.userState.userInfo.state || "").slice(0, 2);
    deliveryCost = deliveryCost + (getAreaCost(postalCode) * 2)
  } else {
    deliveryCost = deliveryCost + ((materialsQuantity * 6) * 2) // $6/sqft of material
  }
  return deliveryCost
}
